<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="人员" style="width: 250px" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="人员" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="职位" min-width="100" prop="zhiwei"></el-table-column>
          <el-table-column align="center" label="假/休" min-width="100" prop="jiaxiu">
            <template slot-scope="scope">
              <div v-if="scope.row.jiaxiu==0">正常</div>
              <div v-if="scope.row.jiaxiu==1">请假</div>
              <div v-if="scope.row.jiaxiu==2">休息</div>
              <div v-if="scope.row.jiaxiu==3">离职</div>
            </template>
          </el-table-column>
          
          <el-table-column align="center" label="淋洗工时" min-width="100" prop="linxigongshi"></el-table-column>
          <el-table-column align="center" label="枪手一线白班工时" min-width="100" prop="qsgsbaiban1"></el-table-column>
          <el-table-column align="center" label="枪手一线白班1工时" min-width="100" prop="qsgsbaiban11"></el-table-column>
          <el-table-column align="center" label="枪手二线白班工时" min-width="100" prop="qsgsbaiban2"></el-table-column>
          <el-table-column align="center" label="枪手二线白班1工时" min-width="100" prop="qsgsbaiban21"></el-table-column>
          <el-table-column align="center" label="枪手三线白班工时" min-width="100" prop="qsgsbaiban3"></el-table-column>
          <el-table-column align="center" label="枪手三线白班1工时" min-width="100" prop="qsgsbaiban31"></el-table-column>
          <el-table-column align="center" label="枪手四线白班工时" min-width="100" prop="qsgsbaiban4"></el-table-column>
          <el-table-column align="center" label="枪手四线白班1工时" min-width="100" prop="qsgsbaiban41"></el-table-column>
          <el-table-column align="center" label="枪手其他工时" min-width="100" prop="qsgsbaiban5"></el-table-column>
          <el-table-column align="center" label="普工一线白班工时" min-width="100" prop="pggsbaiban1"></el-table-column>
          <el-table-column align="center" label="普工一线白班1工时" min-width="100" prop="pggsbaiban11"></el-table-column>
          <el-table-column align="center" label="普工二线白班工时" min-width="100" prop="pggsbaiban2"></el-table-column>
          <el-table-column align="center" label="普工二线白班1工时" min-width="100" prop="pggsbaiban21"></el-table-column>
          <el-table-column align="center" label="普工三线白班工时" min-width="100" prop="pggsbaiban3"></el-table-column>
          <el-table-column align="center" label="普工三线白班1工时" min-width="100" prop="pggsbaiban31"></el-table-column>
          <el-table-column align="center" label="普工四线白班工时" min-width="100" prop="pggsbaiban4"></el-table-column>
          <el-table-column align="center" label="普工四线白班1工时" min-width="100" prop="pggsbaiban41"></el-table-column>
          <el-table-column align="center" label="普工其他工时" min-width="100" prop="pggsbaiban5"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期" @change="riqichange"></el-date-picker>
        </el-form-item>
        <div v-if="tzgzMbInfo.id>0">
          <div style="display: flex;margin-bottom: 20px;">
            <div style="width: 150px;text-align: right;">
              <div>工序</div>
              <div>当日工资</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>前处理装框</div>
              <div>{{tzgzMbInfo.zhuangkuang}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>前处理淋洗</div>
              <div>{{tzgzMbInfo.linxi}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>枪手一线白班</div>
              <div>{{tzgzMbInfo.qsbaiban1}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>枪手二线白班</div>
              <div>{{tzgzMbInfo.qsbaiban2}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>枪手三线白班</div>
              <div>{{tzgzMbInfo.qsbaiban3}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>枪手四线白班</div>
              <div>{{tzgzMbInfo.qsbaiban4}}</div>
            </div>
          </div>
          <div style="display: flex;margin-bottom: 20px;">
            <div style="width: 150px;text-align: right;">
              <div>工序</div>
              <div>当日工资</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>枪手一线白班1</div>
              <div>{{tzgzMbInfo.qsbaiban11}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>枪手二线白班1</div>
              <div>{{tzgzMbInfo.qsbaiban21}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>枪手三线白班1</div>
              <div>{{tzgzMbInfo.qsbaiban31}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>枪手四线白班1</div>
              <div>{{tzgzMbInfo.qsbaiban41}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>枪手其他</div>
              <div>{{tzgzMbInfo.qsbaiban5}}</div>
            </div>
          </div>
          <div style="display: flex;margin-bottom: 20px;">
            <div style="width: 150px;text-align: right;">
              <div>工序</div>
              <div>当日工资</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>普工一线白班</div>
              <div>{{tzgzMbInfo.pgbaiban1}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>普工二线白班</div>
              <div>{{tzgzMbInfo.pgbaiban2}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>普工三线白班</div>
              <div>{{tzgzMbInfo.pgbaiban3}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>普工四线白班</div>
              <div>{{tzgzMbInfo.pgbaiban4}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;">
              <div>普工其他</div>
              <div>{{tzgzMbInfo.pgbaiban5}}</div>
            </div>
          </div>
          <div style="display: flex;margin-bottom: 20px;">
            <div style="width: 150px;text-align: right;">
              <div>工序</div>
              <div>当日工资</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>普工一线白班1</div>
              <div>{{tzgzMbInfo.pgbaiban11}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>普工二线白班1</div>
              <div>{{tzgzMbInfo.pgbaiban21}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>普工三线白班1</div>
              <div>{{tzgzMbInfo.pgbaiban31}}</div>
            </div>
            <div style="text-align: center;margin-left: 10px;width: 85px;white-space: nowrap;">
              <div>普工四线白班1</div>
              <div>{{tzgzMbInfo.pgbaiban41}}</div>
            </div>
          </div>
        </div>
        
        <el-form-item label="人员" prop="renyuan">
          <div style="display: flex;">
            <el-input v-model="editForm.renyuan" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.renyuan" multiple filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in memberSelectList"
                :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="职位" prop="zhiwei">
          <div style="display: flex;">
            <el-input v-model="editForm.zhiwei" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.zhiwei" filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in zhiweiSelectList"
                :key="index" :label="item.zhiwei" :value="item.zhiwei">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="假/休" prop="jiaxiu">
          <el-radio-group v-model="editForm.jiaxiu">
            <el-radio-button :label="0">正常</el-radio-button>
            <el-radio-button :label="1">请假</el-radio-button>
            <el-radio-button :label="2">休息</el-radio-button>
            <el-radio-button :label="3">离职</el-radio-button>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="淋洗工时" prop="linxigongshi">
          <el-input-number v-model="editForm.linxigongshi" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手一线白班工时" prop="qsgsbaiban1">
          <el-input-number v-model="editForm.qsgsbaiban1" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手一线白班1工时" prop="qsgsbaiban11">
          <el-input-number v-model="editForm.qsgsbaiban11" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手二线白班工时" prop="qsgsbaiban2">
          <el-input-number v-model="editForm.qsgsbaiban2" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手二线白班1工时" prop="qsgsbaiban21">
          <el-input-number v-model="editForm.qsgsbaiban21" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手三线白班工时" prop="qsgsbaiban3">
          <el-input-number v-model="editForm.qsgsbaiban3" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手三线白班1工时" prop="qsgsbaiban31">
          <el-input-number v-model="editForm.qsgsbaiban31" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手四线白班工时" prop="qsgsbaiban4">
          <el-input-number v-model="editForm.qsgsbaiban4" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手四线白班1工时" prop="qsgsbaiban41">
          <el-input-number v-model="editForm.qsgsbaiban41" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手其他工时" prop="qsgsbaiban5">
          <el-input-number v-model="editForm.qsgsbaiban5" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工一线白班工时" prop="pggsbaiban1">
          <el-input-number v-model="editForm.pggsbaiban1" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工一线白班1工时" prop="pggsbaiban11">
          <el-input-number v-model="editForm.pggsbaiban11" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工二线白班工时" prop="pggsbaiban2">
          <el-input-number v-model="editForm.pggsbaiban2" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工二线白班1工时" prop="pggsbaiban21">
          <el-input-number v-model="editForm.pggsbaiban21" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工三线白班工时" prop="pggsbaiban3">
          <el-input-number v-model="editForm.pggsbaiban3" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工三线白班1工时" prop="pggsbaiban31">
          <el-input-number v-model="editForm.pggsbaiban31" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工四线白班工时" prop="pggsbaiban4">
          <el-input-number v-model="editForm.pggsbaiban4" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工四线白班1工时" prop="pggsbaiban41">
          <el-input-number v-model="editForm.pggsbaiban41" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工其他工时" prop="pggsbaiban5">
          <el-input-number v-model="editForm.pggsbaiban5" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    renyuan: "",
    zhiwei: "",
    jiaxiu: 0,
    
    linxigongshi: 0,
    qsgsbaiban1: 0,
    qsgsbaiban11: 0,
    qsgsbaiban2: 0,
    qsgsbaiban21: 0,
    qsgsbaiban3: 0,
    qsgsbaiban31: 0,
    qsgsbaiban4: 0,
    qsgsbaiban41: 0,
    qsgsbaiban5: 0,
    pggsbaiban1: 0,
    pggsbaiban11: 0,
    pggsbaiban2: 0,
    pggsbaiban21: 0,
    pggsbaiban3: 0,
    pggsbaiban31: 0,
    pggsbaiban4: 0,
    pggsbaiban41: 0,
    pggsbaiban5: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      memberSelectList: [],
      gongxuSelectList: [],
      zhiweiSelectList: [],
      orderValue: '',
      gongxuValue: '',
      tzgzMbInfo: {},
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
    this.getMemberSelectList()
    this.getZhiweiSelectList()
  },
  
  methods: {
    riqichange(e) {
      console.log(e)
      if(e>0) {
        let riqi = parseInt(e/1000)
        this.getTzgzMbInfo(riqi)
      }
    },
    getTzgzMbInfo(riqi) {
      this.$request.post('/index.php/admin/Ordermodel/tzgzMbRiqiInfo', {riqi: riqi}).then((res) => {
        if(res.data.data) {
          this.tzgzMbInfo = res.data.data
          this.tzgzMbInfo.riqi = parseInt(this.tzgzMbInfo.riqi*1000)
        }else{
          this.tzgzMbInfo = {}
        }
      }).catch(err => {
        console.log(err)
      })
    },
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].kehu==arr[0]&&
        this.orderSelectList[i].dingdanhao==arr[1]&&
        this.orderSelectList[i].huohao==arr[2]&&
        this.orderSelectList[i].chanpinguige==arr[3]&&
        this.orderSelectList[i].yanse==arr[4]&&
        this.orderSelectList[i].xuhao==arr[5]) {
          this.editForm.kehu = this.orderSelectList[i].kehu;
          this.editForm.dingdanhao = this.orderSelectList[i].dingdanhao;
          this.editForm.huohao = this.orderSelectList[i].huohao;
          this.editForm.chanpinguige = this.orderSelectList[i].chanpinguige;
          this.editForm.dingdanshuliang = this.orderSelectList[i].dingdanshuliang;
          this.editForm.yanse = this.orderSelectList[i].yanse;
          this.editForm.xuhao = this.orderSelectList[i].xuhao;
          
          this.gongxuValue = ''
          this.editForm.wuliaomingcheng = '';
          this.editForm.wuliaoguige = '';
          this.editForm.caizhi = '';
          this.editForm.dansanyongliang = 0;
          this.editForm.dangenmianji = 0;
          this.editForm.zhixinglinxi = 0;
          this.editForm.zhixingzhuangkuang = 0;
          this.editForm.chengkongzhuangkuang = 0;
          this.editForm.chengkonglinxi = 0;
          
          if(this.orderSelectList[i].gongxuArr) {
            this.gongxuSelectList = JSON.parse(this.orderSelectList[i].gongxuArr)
          }else{
            this.gongxuSelectList = []
          }
        }
      }
    },
    
    gongxuChange(e) {
      for(let i in this.gongxuSelectList) {
        if(this.gongxuSelectList[i].wuliaomingcheng==e) {
          this.editForm.wuliaomingcheng = this.gongxuSelectList[i].wuliaomingcheng;
          this.editForm.wuliaoguige = this.gongxuSelectList[i].wuliaoguige;
          this.editForm.caizhi = this.gongxuSelectList[i].caizhi;
          this.editForm.dansanyongliang = this.gongxuSelectList[i].dansanyongliang;
          this.editForm.dangenmianji = this.gongxuSelectList[i].dangenmianji;
          this.editForm.zhixinglinxi = this.gongxuSelectList[i].zhixinglinxi;
          this.editForm.zhixingzhuangkuang = this.gongxuSelectList[i].zhixingzhuangkuang;
          this.editForm.chengkongzhuangkuang = this.gongxuSelectList[i].chengkongzhuangkuang;
          this.editForm.chengkonglinxi = this.gongxuSelectList[i].chengkonglinxi;
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/ordermodel/tzgzMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getZhiweiSelectList() {
      this.$request.post('/index.php/admin/admin/zhiweiSelect').then((res) => {
        this.zhiweiSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.today = ''
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      if(form.renyuan) {
        this.editForm.renyuan = form.renyuan
      }
      if(form.zhiwei) {
        this.editForm.zhiwei = form.zhiwei
      }
      this.tzgzMbInfo = {}
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/gongzi/tzgzInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.getTzgzMbInfo(this.editForm.riqi)
        this.editForm.renyuan = [this.editForm.renyuan]
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/gongzi/tzgzDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/gongzi/tzgzSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
        data.day = this.today.getDate()
      }
      this.$request.post('/index.php/admin/gongzi/tzgzList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
